<template>
  <section class="book pt-16 px-4 px-sm-10">
    <ErrorAlert :error-message="errorMessage" v-if="btnError">
      {{ bookData.bookErrorTitle }}<br class="d-block d-md-none" />
      {{ bookData.bookErrorDescription }}
    </ErrorAlert>
    <PaymentMethodDialog
      @onSubmit="onPaymentSubmitHandler"
      @onClose="paymentDialog = false"
      :value="paymentDialog"
    />
    <v-dialog persistent v-model="bookDialog" width="unset" max-width="340">
      <v-card class="pt-5">
        <v-card-text>
          <h5 class="text-h5 mb-2">
            {{ bookDialogTitle }}
          </h5>
          <p>
            {{ bookDialogDescription }}
          </p>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#FFA903" text @click="onDialogSubmitHandler">
              {{ bookDialogButtonTitle }}
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="book__header d-flex align-center mt-14 mb-7">
      <v-btn
        @click="goBack"
        fab
        icon
        small
        outlined
        color="#FFA903"
        class="mr-5"
      >
        <v-icon>
          mdi-chevron-left
        </v-icon>
      </v-btn>
      <h2>{{ bookData.title }}</h2>
      <span>{{ bookData.subtitle }}</span>
    </div>
    <div class="divider"></div>
    <div class="book__wrapper">
      <v-row>
        <v-col cols="12" class="col-sm-9">
          <v-expansion-panels v-model="panel" flat tile class="book__adults">
            <v-expansion-panel
              v-for="(adult, index) in adultsForm"
              :key="index"
              class="book__adults-item"
            >
              <v-expansion-panel-header class="text-capitalize"
                >{{ index + 1 }}
                {{ bookData.adultsValue }}</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <div class="pb-5">
                  <adult-form
                    :value="adult"
                    @submitAdultForm="submitAdultForm($event, index)"
                    @applyCoupon="applyCoupon($event, index)"
                    :short="isSingleRegister"
                  ></adult-form>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel
              v-for="(children, index) in childrenForm"
              :key="`children-${index}`"
              class="book__adults-item"
            >
              <v-expansion-panel-header class="text-capitalize"
                >{{ index + 1 }}
                {{ bookData.teensValue }}</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <div class="pb-5">
                  <child-form
                    @submitChildrenForm="submitChildrenForm($event, index)"
                    :value="children"
                    :short="isSingleRegister"
                  />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel
              v-for="(babies, index) in babiesForm"
              :key="`babies-${index}`"
              class="book__adults-item"
            >
              <v-expansion-panel-header class="text-capitalize"
                >{{ index + 1 }}
                {{ bookData.kidsValue }}</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <div class="pb-5">
                  <child-form
                    @submitChildrenForm="submitBabiesForm($event, index)"
                    :value="babies"
                    :short="isSingleRegister"
                  />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- eslint-disable vue/valid-v-model -->
          <donation-field
            :checked="isDonationAvailable"
            :input="donation"
            @onCheckboxChange="onDonationCheckboxChangeHandler"
            @onInputChange="onDonationInputChangeHandler"
          />
          <!-- eslint-enable -->
        </v-col>
        <v-col cols="12" class="col-sm-3">
          <v-card
            :color="btnError && 'red lighten-2'"
            :dark="btnError"
            flat
            tile
            class="book__card pa-7"
          >
            <div class="mb-7" v-if="!isSingleRegister">
              <BedIcon class="book__card-img" v-if="room.bedsCount === 1" />
              <TwoBedIcon class="book__card-img" v-else />
            </div>
            <div class="book__card-title">
              <h3>{{ room.title }}</h3>
            </div>
            <div class="book__card-places">
              <div
                class="book__card-places-item d-flex align-center"
                v-for="(value, index) in adultsPlaces"
                :key="index"
              >
                <p class="my-2 mr-5">
                  {{ index + 1 }} {{ bookData.adultsValue }}
                </p>
                <p v-if="!value" style="color: #CECED8" class="my-2">
                  {{ bookData.notFilledValue }}
                </p>
                <div v-else class=" d-flex align-center">
                  <p style="color: #FFA903" class="my-2 mr-3">
                    {{ bookData.filledValue }}
                  </p>
                  <v-icon size="18" color="#FFA903">mdi-check</v-icon>
                </div>
              </div>

              <div
                class="book__card-places-item d-flex align-center"
                v-for="(value, index) in childrenPlaces"
                :key="index"
              >
                <p class="my-2 mr-5">
                  {{ index + 1 }} {{ bookData.teensValue }}
                </p>
                <p v-if="!value" style="color: #CECED8" class="my-2">
                  {{ bookData.notFilledValue }}
                </p>
                <div v-else class=" d-flex align-center">
                  <p style="color: #FFA903" class="my-2 mr-3">
                    {{ bookData.filledValue }}
                  </p>
                  <v-icon size="18" color="#FFA903">mdi-check</v-icon>
                </div>
              </div>

              <div
                class="book__card-places-item d-flex align-center"
                v-for="(value, index) in babiesPlaces"
                :key="index"
              >
                <p class="my-2 mr-5">
                  {{ index + 1 }} {{ bookData.kidsValue }}
                </p>
                <p v-if="!value" style="color: #CECED8" class="my-2">
                  {{ bookData.notFilledValue }}
                </p>
                <div v-else class=" d-flex align-center">
                  <p style="color: #FFA903" class="my-2 mr-3">
                    {{ bookData.filledValue }}
                  </p>
                  <v-icon size="18" color="#FFA903">mdi-check</v-icon>
                </div>
              </div>
            </div>
            <p v-if="isDonationAvailable && donation">
              {{ bookData.lsaranHelpLabel }}: {{ donation | numberWithSpaces }}
            </p>
            <div>
              <p
                class="coupon"
                v-for="(adult, index) in adultsForm"
                :key="index"
              >
                <span v-if="adult.coupon > 0">
                  {{ bookData.couponField }} {{ index + 1 }}:
                  {{ -adult.coupon }} {{ commonData.currency }}
                </span>
              </p>
            </div>
            <v-divider></v-divider>
            <h5 class="mt-4 mb-7">
              {{ bookData.priceValue }}: {{ roomSum | numberWithSpaces }}
              {{ commonData.currency }}
            </h5>

            <PrivacyStatement v-model="personalData" />

            <v-btn
              :disabled="!bookBtn"
              width="100%"
              height="40"
              class="main-btn mt-5"
              @click="paymentDialog = true"
              :loading="btnLoading"
              :color="btnError && 'error'"
            >
              {{ bookData.bookSubmitTitle }}
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import AdultForm from "@/components/AdultForm";
import ChildForm from "@/components/ChildForm";
import { excludeKey } from "@/utils/excludeKey";
import { postForm, postSingleRegisterForm } from "@/api/registration";
import { checkKeyRoom } from "@/utils/sessionKey";
import BedIcon from "@/components/icons/BedIcon";
import TwoBedIcon from "@/components/icons/TwoBedIcon";
import PrivacyStatement from "@/components/PrivacyStatement";
import ErrorAlert from "@/components/alert/ErrorAlert";
import { getNumberWithSpaces } from "@/utils/getNumberWithSpaces";
import PaymentMethodDialog, {
  PaymentType
} from "@/components/payment-method-dialog/PaymentMethodDialog";
import DonationField from "@/components/donation-filed/DonationField.vue";

export default {
  name: "Book",
  components: {
    DonationField,
    PaymentMethodDialog,
    ErrorAlert,
    PrivacyStatement,
    TwoBedIcon,
    BedIcon,
    ChildForm,
    AdultForm
  },
  filters: {
    numberWithSpaces(value) {
      return getNumberWithSpaces(value);
    }
  },
  beforeRouteEnter(to, from, next) {
    const isSinglePage = !!localStorage.getItem("single-page");
    if (isSinglePage || checkKeyRoom()) next();
    else next("register");
  },
  computed: {
    bookData() {
      return this.$t("book");
    },
    commonData() {
      return this.$t("common");
    },
    bookDialogTitle() {
      return this.paymentType === PaymentType.MIR
        ? this.bookData.mirRegistrationTitle
        : this.bookData.successRegistrationTitle;
    },
    bookDialogDescription() {
      return this.paymentType === PaymentType.MIR
        ? this.bookData.mirRegistrationDescription
        : this.bookData.successRegistrationDescription;
    },
    bookDialogButtonTitle() {
      return this.paymentType === PaymentType.MIR
        ? this.bookData.mirRegistrationButtonTitle
        : this.bookData.successRegistrationButtonTitle;
    },
    isSingleRegister() {
      const isSingleRegister = localStorage.getItem("single-page");
      return !!isSingleRegister;
    },
    formCount() {
      return (
        this.adultsForm.length +
        this.childrenForm.length +
        this.babiesForm.length
      );
    },
    room() {
      const storageRoom = localStorage.getItem("room");
      return storageRoom
        ? JSON.parse(storageRoom)
        : this.$store.getters.getRoom;
    },
    formInfo() {
      const storageForm = localStorage.getItem("form");
      return storageForm
        ? JSON.parse(storageForm)
        : this.$store.getters.getFormInfo;
    },
    roomSum() {
      let res = this.room.price;
      // if (this.helpLsaran) res += this.helpSum;
      this.adultsForm.forEach(adult => {
        res -= adult.coupon;
      });
      const isDonation = this.isDonationAvailable && this.donation;
      return res + (isDonation ? +this.donation : 0);
    },
    bookBtn() {
      return (
        this.personalData &&
        this.adultsPlaces.every(el => el) &&
        this.childrenPlaces.every(el => el) &&
        this.babiesPlaces.every(el => el)
      );
    }
  },
  data: () => ({
    btnLoading: false,
    btnError: false,
    errorMessage: null,
    formData: {
      adults: [],
      children: [],
      babies: [],
      donation: 0
    },
    panel: 0,
    adultsPlaces: [],
    adultsForm: [],
    childrenPlaces: [],
    childrenForm: [],
    babiesPlaces: [],
    babiesForm: [],
    isDonationAvailable: true,
    personalData: true,
    bookDialog: false,
    paymentDialog: false,
    donation: 5000,
    paymentType: PaymentType.OTHER
  }),
  mounted() {
    this.initAdultsForm();
    this.initChildrenForm(
      this.formInfo.children,
      this.childrenForm,
      this.childrenPlaces,
      "children"
    );
    this.initChildrenForm(
      this.formInfo.babies,
      this.babiesForm,
      this.babiesPlaces,
      "babies"
    );
  },
  methods: {
    help(sum) {
      this.helpSum = sum;
    },

    onDonationCheckboxChangeHandler(value) {
      this.isDonationAvailable = value;
    },

    onDonationInputChangeHandler(value) {
      this.donation = value;
    },

    clearStorage() {
      localStorage.removeItem("form-data");
      localStorage.removeItem("form");
      localStorage.removeItem("room");
      localStorage.removeItem("session-key");
      localStorage.removeItem("single-page");
    },

    submitAdultForm(value, index) {
      this.panel = this.panel === this.formCount - 1 ? [] : this.panel + 1;
      this.adultsForm[index] = value;
      this.$set(this.adultsPlaces, index, true);
      this.formData.adults = this.adultsForm;
      this.saveFormData();
    },

    applyCoupon(value, index) {
      this.adultsForm[index] = value;
      this.formData.adults = this.adultsForm;
      this.saveFormData();
    },

    submitChildrenForm(value, index) {
      this.panel++;
      this.childrenForm[index] = value;
      this.$set(this.childrenPlaces, index, true);
      this.formData.children = this.childrenForm;
      this.saveFormData();
    },

    submitBabiesForm(value, index) {
      this.panel++;
      this.babiesForm[index] = value;
      this.$set(this.babiesPlaces, index, true);
      this.formData.babies = this.babiesForm;
      this.saveFormData();
    },

    onDialogSubmitHandler() {
      this.clearStorage();
      this.bookDialog = false;
      this.$router.push("/");
    },

    async onPaymentSubmitHandler(paymentType) {
      this.paymentDialog = false;
      this.btnLoading = true;
      this.paymentType = paymentType;
      const isDonationAvailable = this.isDonationAvailable && this.donation;
      try {
        const key = this.$store.getters.getSessionKey.key;
        const body = {
          adults: this.adultsForm.map(adult => excludeKey(adult, "coupon")),
          children: this.childrenForm,
          babies: this.babiesForm,
          donation: isDonationAvailable ? +this.donation : 0,
          mirCard: paymentType === PaymentType.MIR,
          food: !!this.room?.food
        };
        const lang = this.$i18n.locale ?? "en";
        const result = this.isSingleRegister
          ? await postSingleRegisterForm(body, lang)
          : await postForm(key, body, lang);
        if (result) {
          if (paymentType === PaymentType.MIR) {
            this.bookDialog = true;
          } else if ("redirectUrl" in result) {
            window.location.href = result.redirectUrl;
          }
          this.clearStorage();
        }
      } catch (error) {
        this.errorMessage = error.message;
        this.btnError = true;
        await this.$vuetify.goTo(0);
      }
      this.btnLoading = false;
    },

    initAdultsForm() {
      const data = localStorage.getItem("form-data");
      const adultsData = data && JSON.parse(data).adults;
      if (adultsData && adultsData.length > 0) {
        this.adultsForm = adultsData;
        this.adultsForm.forEach(() => {
          this.adultsPlaces.push(false);
        });
        return;
      }
      for (let i = 0; i < this.formInfo.adults; ++i) {
        this.$set(this.adultsForm, i, {
          lastName: null,
          firstName: null,
          patronymic: null,
          phone: null,
          email: null,
          couponCode: null,
          passport: null,
          passportGivenWhen: null,
          passportGivenBy: null,
          registerAddress: null,
          birthday: null,
          coupon: 0
        });
        this.adultsPlaces.push(false);
      }
    },

    initChildrenForm(childrenCount, childrenForm, childrenPlaces, type) {
      const data = localStorage.getItem("form-data");
      const childrenData = data && JSON.parse(data)[type];
      for (let i = 0; i < childrenCount; ++i) {
        this.$set(
          childrenForm,
          i,
          childrenData && childrenData.length > 0
            ? childrenData[i]
            : {
                lastName: null,
                firstName: null,
                patronymic: null,
                phone: null,
                birthday: null,
                birthCertificate: null
              }
        );
        childrenPlaces.push(false);
      }
    },

    goBack() {
      localStorage.clear();
      this.$router.push("/register");
    },

    saveFormData() {
      localStorage.setItem("form-data", JSON.stringify(this.formData));
    }
  }
};
</script>

<style lang="sass" scoped>
@import "./src/assets/style/vars"

@media (max-width: 600px)
  .help__check
    width: 100% !important

@media only screen and (min-width: 600px) and (max-width: 1264px)
  .help__check
    width: 80% !important

.book
  min-height: 100vh
  color: $dark
  &__header
    font-size: 2rem
    span
      font-weight: normal
      line-height: 48px
      letter-spacing: 0.01em
      color: $dark
      opacity: 0.2
      margin-left: 10px
  &__adults
    width: 100%
    font-weight: 700
    &-item
      border: 1px solid $dark !important
      box-sizing: border-box
      margin: 15px 0 !important
  &__card
    margin: 15px 0 !important
    background: #F9F7FC
    &-img
      width: 3.2em
      height: 3.2em
    &-places
      &-item
        font-size: 16px

.form-input
  label
    display: block
  input
    border-radius: 0 !important
    border: 1px solid rgba(#2F2E43, .2) !important
    outline: none !important
    width: 100%
    min-height: 40px
    padding: 8px 20px
    box-sizing: border-box !important
    font-family: Roboto, sans-serif
    font-style: normal
    font-weight: normal
    font-size: 16px
    line-height: 24px
    color: $dark !important

.help
  width: 100%
  background: #F3F9FC
  &__check
    width: 60%
  &__sum
    color: $second
    &-item
      cursor: pointer
      margin: 0 15px
      font-weight: 700
      padding-bottom: 8px
      &:hover
        color: $prime
        border-bottom: 2px solid $prime

.help-active
  color: $prime !important
  border-bottom: 2px solid $prime !important

.coupon
  color: #43A047
  font-weight: 600
  margin-bottom: 0
</style>
